export const toStructuredFromConfig = (config) => {
  const configv2data = config.v2data;

  const {
    sectionsById,
    pageScopedCss,
    isInPageSearchEnabled,
    isSecondaryLogoEnabled,
    isMobileRenderEnabled,
    shouldShowHeader,
    shouldShowTitle,
    shouldShowSocialLinks,
    socialLinks,
    menuItemsById,
    orderedMenuItemIds,
    secondaryLogoData,
    subpagesById,
    isFullBleed,
    displayAnchorLinks,
    isInlineHeaderStyle,
    headerContentPosition,
    isUsingLegacyHeader,
    sectionOverridesBySectionId
  } = configv2data;

  return {
    // config
    pageConfigId: config.id,
    themeUuid: config.lens_style_uuid,
    siteViewerVersion: config.site_viewer_version,
    translationsIsEnabled: config.translations_is_enabled,
    translationsDefaultLanguageIso: config.translations_default_language_iso,
    translationsAppliedLanguages: config.translations_applied_languages,
    // v2data
    pageScopedCss,
    sectionsById,
    isInPageSearchEnabled,
    isSecondaryLogoEnabled,
    isMobileRenderEnabled,
    shouldShowHeader,
    shouldShowTitle,
    shouldShowSocialLinks,
    socialLinks,
    menuItemsById,
    orderedMenuItemIds,
    secondaryLogoData,
    subpagesById,
    // new header data
    isFullBleed,
    displayAnchorLinks,
    isInlineHeaderStyle,
    headerContentPosition,
    isUsingLegacyHeader,

    sectionOverridesBySectionId
  };
};

export const toConfigApiModel = (apiModelData) => {
  const {
    // style
    themeUuid,
    siteViewerVersion,
    translationsIsEnabled,
    translationsDefaultLanguageIso,
    translationsAppliedLanguages
  } = apiModelData;

  const configv2data = {
    pageScopedCss: apiModelData.pageScopedCss,
    isInPageSearchEnabled: apiModelData.isInPageSearchEnabled,
    isSecondaryLogoEnabled: apiModelData.isSecondaryLogoEnabled,
    isMobileRenderEnabled: apiModelData.isMobileRenderEnabled,
    shouldShowHeader: apiModelData.shouldShowHeader,
    shouldShowTitle: apiModelData.shouldShowTitle,
    shouldShowSocialLinks: apiModelData.shouldShowSocialLinks,
    socialLinks: apiModelData.socialLinks,
    menuItemsById: apiModelData.menuItemsById,
    orderedMenuItemIds: apiModelData.orderedMenuItemIds,
    secondaryLogoData: apiModelData.secondaryLogoData,
    subpagesById: apiModelData.subpagesById,
    sectionsById: apiModelData.sectionsById,
    // new header data
    isFullBleed: apiModelData.isFullBleed,
    displayAnchorLinks: apiModelData.displayAnchorLinks,
    isInlineHeaderStyle: apiModelData.isInlineHeaderStyle,
    headerContentPosition: apiModelData.headerContentPosition,
    isUsingLegacyHeader: apiModelData.isUsingLegacyHeader,

    sectionOverridesBySectionId: apiModelData.sectionOverridesBySectionId
  };

  return {
    lens_style_uuid: themeUuid,
    site_viewer_version: siteViewerVersion,
    translations_is_enabled: translationsIsEnabled,
    translations_default_language_iso: translationsDefaultLanguageIso,
    translations_applied_languages: translationsAppliedLanguages,
    v2data: configv2data,
  };
};
